import { pushToDataLayer } from '@domain-group/fe-helper';
import { getGa4PageProps, getGa4UserProps, sanitizeGa4Value } from '../utils';
import { sendToMixpanel, getUserProps } from '../mixpanel';
import getEntryPoint from '../get-entry-point';
import type { SearchResultsBaseProperties } from './search-results-base-properties';

export interface TapAgencyCardProps {
  baseProperties?: SearchResultsBaseProperties;
  subCategory2: string;
  cardPosition: number;
  reviewRating: boolean;
  reviewCount?: number;
  starRating?: number;
  agencyId: number;
  agencyName: string;
}

function trackTapAgencyCard({
  baseProperties = {},
  subCategory2,
  cardPosition,
  reviewRating,
  reviewCount,
  starRating,
  agencyId,
  agencyName,
}: TapAgencyCardProps): void {
  const entryPoint = getEntryPoint();
  const dataLayerAgencyName = sanitizeGa4Value(agencyName);

  sendToMixpanel('Tap Agency Card', {
    siteSection: 'Agents',
    ...(entryPoint && { entryPoint }),
    ...baseProperties,
    ...getUserProps(),
    subCategory2,
    cardPosition,
    reviewRating,
    ...(typeof reviewCount === 'number' && { reviewCount }),
    ...(typeof starRating === 'number' && { starRating }),
    agencyId: `${agencyId}`,
    agencyName,
  });

  const suburbNames = baseProperties.searchFilterSuburb?.join('; ') ?? '';
  const resultCount = baseProperties.searchResultsReturnedCount;
  const resultCountLabel =
    typeof resultCount === 'number' ? `${resultCount} ` : '';
  const agencyListLabel =
    resultCount === 1 ? 'Real estate agency' : 'Real estate agencies';
  const elementListName = sanitizeGa4Value(
    [
      `${resultCountLabel}${agencyListLabel}`,
      suburbNames && `in ${suburbNames}`,
    ]
      .filter(Boolean)
      .join(' '),
  );

  pushToDataLayer({
    event: 'profile_select',
    event_parameters: {
      agency_agent_id: '',
      agency_agent_name: '',
      agency_id: `${agencyId}`,
      agency_name: dataLayerAgencyName,
      ...getGa4PageProps(),
      info_category_sub2: subCategory2,
      element_list_name: elementListName,
      element_list_position: cardPosition,
      element_text: dataLayerAgencyName,
      element_title: dataLayerAgencyName,
      element_type: 'Agency card',
    },
    user_properties: getGa4UserProps(),
  });
}

export default trackTapAgencyCard;
